exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#jitsiConferenceFrame0{height:400px;margin-right:40px}#jitsi-container{position:relative}.actions-wrapper{display:flex;flex-direction:column;position:absolute;top:0;right:0;background-color:#fff;padding:10px;align-items:center;transform:translateX(100%)}.actions-wrapper button{margin-right:10px}.alert-wrapper{display:flex;flex-wrap:wrap;width:80%}.alert-wrapper .alert{margin-right:5px;margin-bottom:1px!important;padding:1%}.alert-wrapper .alert i.v-icon{margin-right:0!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-993ec6bc","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/JitsiMeeting.vue
// module id = 825
// module chunks = 0